module.exports = __webpack_public_path__ + "img/expostyle_1195_carbon_pantone2336c.873bfdb6.jpg";